<template>
  <div class="row">
    <div class="col-md-12">
      <div class="filter-component">
        <div class="row col-12 mx-0 px-0">
          <div class="col-md-3 mb-4">
            <Typography
              text="Fecha"
              variant="CTA"
              color="#5d5fef"
              class="border-filters-title"
            />
            <div class="pt-2 space-y-4">
              <Date
                name="init_date"
                label="Inicio"
                v-model="valuesFilter.init_date"
                :value="valuesFilter.init_date"
                :max="valuesFilter.end_date"
                :disabled="loading"
              />
              <Date
                name="end_date"
                label="Fin"
                v-model="valuesFilter.end_date"
                :value="valuesFilter.end_date"
                :min="valuesFilter.init_date"
                :max="finalDate"
                :disabled="valuesFilter.init_date ? false : true"
              />
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <Typography
              text="Área"
              variant="CTA"
              color="#5d5fef"
              class="border-filters-title"
            />
            <div class="pt-2 space-y-4">
              <SelectSearch
                label="Área"
                name="name"
                :options="areas"
                :value="valuesFilter.area"
                :required="false"
                :loading="loadingArea"
                :disabled="false"
                :placeholder="'Selecciona un área'"
                @input="(value) => (valuesFilter.area = value)"
              />
              <!-- <Select
                label="Área"
                name="area"
                :options="areas"
                :value="valuesFilter.area"
                v-model="valuesFilter.area"
                :disabled="loading"
              /> -->
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <Typography
              text="Ubicación"
              variant="CTA"
              color="#5d5fef"
              class="border-filters-title"
            />
            <div class="pt-2 space-y-4">
              <SelectSearch
                label="Ubicación"
                name="name"
                :options="locations"
                :value="valuesFilter.location"
                :required="false"
                :loading="loadingLocation"
                :disabled="false"
                :placeholder="'Selecciona un ubicación'"
                @input="(value) => (valuesFilter.location = value)"
              />
              <!-- <Select
                label="Ubicación"
                name="location"
                :options="locations"
                :value="valuesFilter.location"
                v-model="valuesFilter.location"
                :disabled="loading"
              /> -->
            </div>
          </div>
          <div class="col-md-3">
            <Typography
              text="Empleado"
              variant="CTA"
              color="#5d5fef"
              class="border-filters-title"
            />
            <div class="pt-2 space-y-4">
              <SelectSearch
                label="Buscar por Nombre, Sharp ID o N° de Cédula"
                name="name"
                :options="employees"
                :value="valuesFilter.employee"
                :required="false"
                :loading="loadingEmploye"
                :disabled="false"
                :placeholder="'Selecciona un empleado'"
                @input="(value) => (valuesFilter.employee = value)"
                @search="searchEmployee"
              />
              <!-- <Select
                label="Sharp ID o N° Cédula"
                name="employee"
                :options="employees"
                :value="valuesFilter.employee"
                v-model="valuesFilter.employee"
                :disabled="loading"
              /> -->
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <Typography
              text="Tipo de SVE"
              variant="CTA"
              color="#5d5fef"
              class="border-filters-title"
            />
            <div class="pt-2 space-y-4">
              <SelectSearch
                label="Tipo de SVE"
                name="name"
                :options="optionsSVE"
                :value="valuesFilter.type_sve"
                :required="false"
                :loading="false"
                :disabled="false"
                :placeholder="'Selecciona un SVE'"
                @input="(value) => (valuesFilter.type_sve = value)"
              />
              <!-- <Select
                label="Tipo de SVE"
                name="location"
                :options="optionsSVE"
                :value="valuesFilter.type_sve"
                v-model="valuesFilter.type_sve"
                :disabled="loading"
              /> -->
            </div>
          </div>
          <div class="col-md-12 mb-5" v-if="isDisabled">
            <div class="d-flex justify-content-end">
              <Button
                small
                pill
                class="mr-2 search"
                :disabled="loading"
                @click.prevent="submitFilter"
              >
                <span class="mr-2">Aplicar filtros</span>
                <b-spinner v-if="loading" />
              </Button>
              <Button
                small
                pill
                class="clear"
                @click.prevent="clearFilter"
                :disabled="loading || !isDisabled"
              >
                Limpiar filtros
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getLocations,
  getAreas,
  getEmployees,
} from "@/services/health-tracker/diagnostic/service";
import Typography from "@/components/general/Typography";
import useInputs from "@/components/general/Inputs";
const { Select, Date, SelectSearch, Button } = useInputs();
export default {
  components: {
    Typography,
    Select,
    Date,
    Button,
    SelectSearch,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    optionsSVE: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      valuesFilter: {
        type_sve: null,
        location: null,
        area: null,
        employee: null,
        init_date: "",
        end_date: "",
      },
      areas: [],
      locations: [],
      employees: [],
      search: null,
      loadingEmploye: false,
      loadingArea: false,
      loadingLocation: false,
      finalDate: "",
    };
  },
  computed: {
    isDisabled() {
      const me = this;
      return Object.values(me.valuesFilter).some(
        (filter) => filter !== null && filter !== ""
      );
    },
  },
  watch: {
    ["valuesFilter.init_date"]: {
      handler() {
        const me = this;
        me.finalDate = "";
        me.valuesFilter.end_date = "";
        me.finalDate = me
          .$moment(me.valuesFilter.init_date)
          .add(1, "year")
          .format("YYYY-MM-DD");
      },
    },
  },
  methods: {
    clearFilter() {
      const me = this;
      me.valuesFilter = {
        type_sve: null,
        location: null,
        area: null,
        employee: null,
        init_date: "",
        end_date: "",
      };
      me.$emit("submitFilter", null);
    },
    submitFilter() {
      const me = this;
      console.log("me.valuesFilter", me.valuesFilter);
      const searchValue = {
        ...(me.valuesFilter.init_date && {
          init_date: me.valuesFilter.init_date,
        }),
        ...(me.valuesFilter.end_date && { end_date: me.valuesFilter.end_date }),
        ...(me.valuesFilter.employee && {
          employee: me.valuesFilter.employee?.id,
        }),
        ...(me.valuesFilter.area && { "area[0]": me.valuesFilter?.area?.id }),
        ...(me.valuesFilter.type_sve && {
          "sve[0]": me.valuesFilter.type_sve.id,
        }),
        ...(me.valuesFilter.location && {
          "location[0]": me.valuesFilter.location.id,
        }),
      };
      me.$emit("submitFilter", searchValue);
    },
    async loadAreas() {
      const me = this;
      me.areas = [];
      me.loadingArea = true;
      try {
        const { data } = await getAreas();
        me.areas = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingArea = false;
      }
    },
    async loadLocations() {
      const me = this;
      me.loadingLocation = true;
      me.locations = [];
      try {
        const { data } = await getLocations();
        me.locations = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingLocation = false;
      }
    },
    async loadEmployees() {
      const me = this;
      me.loadingEmploye = true;
      me.employees = [];
      if (me.abortControllerDiagnostic) {
        me.abortControllerDiagnostic.abort(); // Cancela la petición anterior
      }

      me.abortControllerDiagnostic = new AbortController();
      const signal = me.abortControllerDiagnostic.signal;
      try {
        const { data } = await getEmployees({ search: me.search }, signal);
        data.forEach((x) => {
          me.employees.push({
            id: x?.id,
            name: x?.name_cc_sharp_id,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingEmploye = false;
      }
    },
    onSelectEmployee(value) {
      const me = this;
      me.valuesFilter.employee = value;
    },
    searchEmployee(value) {
      const me = this;
      me.search = value;
      me.loadEmployees();
    },
  },
  mounted() {
    const me = this;
    me.loadAreas();
    me.loadLocations();
    me.loadEmployees();
  },
};
</script>

<style lang="scss" scoped>
.filter-component {
  box-shadow: 0 0rem 0.5rem rgba(0, 0, 0, 0.175);
  border-radius: 12px;
  padding: 15px;
  .search {
    background-color: #5d5fef;
    border-color: #5d5fef;
    padding: 5px 10px;
    height: auto;
    border-radius: 8px;
    color: white;
    border: none;
  }
  .clear {
    background-color: #da1414;
    border-color: #da1414;
    padding: 5px 10px;
    height: auto;
    border-radius: 8px;
    color: white;
    border: none;
  }
}
</style>
